<template>
  <v-app :dark="!light" :light="light">
    <tud-layout></tud-layout>
  </v-app>
</template>

<script>
  import Layout from '@/components/Layout.vue'
  export default {
    components: {
      'tud-layout': Layout
    },
    computed: {
      light () {
        return this.$store.getters.appLight
      }
    },
    created () {
      // only if route is dashboard or something
      this.$store.dispatch('attemptAuth')
    }
  }
</script>

<style lang="stylus">
  @import '../node_modules/vuetify/src/stylus/settings/_colors'
  $theme := {
    primary: #01bd9b
    accent: $blue.accent-2 //#448aff
    secondary: $grey.darken-3 //#424242
    info: $blue.base //#2196f3
    warning: $amber.base //#ffc107
    error: $red.base //#f44336
    success: $green.base //#4caf50
  }
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?0a3f3dfa